// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"5bb1e87e","577":"c9f50963"}[chunkId] + ".chunk.js";
};